<template>
  <section>
    <search-bar />
    <tabsLayout>
      <b-tabs
        :value="currentTabIndex"
        card
        lazy
        active-nav-item-class="font-weight-bold"
        content-class="my-0"
      >
        <b-tab
          v-for="tab of filterTabs"
          :key="tab.key"
          :title="tab.label"
          @click="routerTo(tab)"
          class="px-0"
        />
      </b-tabs>
      <listLayout>
        <router-view :colors="lineColors"></router-view>
      </listLayout>
    </tabsLayout>
  </section>
</template>

<script>
// @ is an alias to /src
import SearchBar from "@/components/SearchBar.vue";
import tabsLayout from "@/layout/TabsLayout.vue";
import listLayout from "@/layout/ListLayout.vue";

const tabs = [
  {
    key: "report-year",
    label: "年表"
  },
  {
    key: "report-ratio-year",
    label: "財務比例分析＿年"
  },
  {
    key: "chart-asset-year",
    label: "資產分析圖＿年"
  },
  {
    key: "chart-profit-year",
    label: "獲利分析圖＿年"
  },
  {
    key: "news-all",
    label: "所有新聞"
  },
  {
    key: "news-owner",
    label: "個人新聞"
  },
  {
    key: "report-quarter",
    label: "季表"
  },
  {
    key: "report-ratio-quarter",
    label: "財務比例分析＿季"
  },
  {
    key: "chart-asset-quarter",
    label: "資產分析圖＿季"
  },
  {
    key: "chart-profit-quarter",
    label: "獲利分析圖＿季"
  },
  {
    key: "survey-all",
    label: "所有研究報告"
  },
  {
    key: "survey-owner",
    label: "個人研究報告"
  }
];
export default {
  name: "Stock",
  components: {
    SearchBar,
    tabsLayout,
    listLayout
  },
  beforeRouteUpdate(to, from, next) {
    //不能用 from path，會取到上一個 currentTabIndex
    const tabName = to.path.split("/")[3];
    //oneNews、oneSurvey 沒有在 tabs 裡，呈現頁面不改動 currentTab
    if (tabName.includes("oneNews")) next();
    else if (tabName.includes("oneSurvey")) next();
    else this.currentTabIndex = this.howIsCurrentTabIndex(tabName);
    next();
  },
  created() {
    const tabName = this.$route.path.split("/")[3];
    this.currentTabIndex = this.howIsCurrentTabIndex(tabName);
  },
  data() {
    return {
      currentTabIndex: 0
    };
  },
  computed: {
    filterTabs() {
      return tabs.filter(tab => {
        if (!this.$store.getters.loggedInInfo.is_admin) {
          return tab.label !== "所有研究報告";
        } else {
          return tab;
        }
      });
    },
    lineColors() {
      return {
        eucalyptus: "#28a745", // 桉樹色
        dodgerBlue: "#007bff", // 道奇色
        fuchsiaBlue: "#6f42c1", // 紫紅色
        amber: "#ffc107", // 琥珀色
        amaranth: "#dc3545", // 莧菜色
        pumpkin: "#fd7e14", // 南瓜色
        pelorous: "#17a2b8", // 藍綠色
        cerise: "#e83e8c", // 櫻桃色,
        mountainMeadow: "#20c997" // 山草甸
      };
    }
  },
  methods: {
    howIsCurrentTabIndex(tabName) {
      return this.filterTabs.findIndex(item => {
        return item.key === tabName;
      });
    },
    routerTo(tab) {
      if (
        tab.key === "news-all" ||
        tab.key === "news-owner" ||
        tab.key === "survey-all" ||
        tab.key === "survey-owner"
      ) {
        this.$router.push({ name: tab.key, query: { page: 1 } });
      } else {
        this.$router.push({ name: tab.key });
      }
    }
  }
};
</script>
<style scoped lang="scss">
::v-deep .nav-tabs .nav-item {
  width: 15%;
  text-align: center;
}
::v-deep .nav-tabs .nav-item:nth-child(5) {
  margin-left: auto;
}
::v-deep .nav-tabs .nav-item:nth-child(11) {
  margin-left: auto;
}
</style>
